module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-MIP-Image-Refresh-3.4b72b31a.png";